module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Номер карты":"Card number","nonUSDhint":"In case of making a payment from a wallet other than {CUR}, a preliminary conversion to {CUR} will be performed."},"ru":{"nonUSDhint":"В случае оформления платежа с кошелька, отличного от {CUR}, будет произведена предварительная конвертация в {CUR}."}}')
  delete Component.options._Ctor
}
